//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PREP',
  data() {
    return {
      defaultJson: {
        "Cancer": "恶性肿瘤",
        "High risk (43%)": "高危（43%）",
        "Low risk (2%)": "低危（2%）",
        "BNP": "BNP（ng/L）",
        "Cardiogenic Shock on Admission": "入院时心源性休克",
        "Moderate risk (12%)": "中危（12%）",
        "Altered Mental State": "精神状态改变（迷失方向、麻木或昏迷）",
        "RV \/ LV Ratio": "右心室/左心室比"
      },
      form: {
        cardiogenicShock: '0',
        alteredMentalState: '0',
        cancer: '0',
        bnp: '',
        rvLvRatio: '',
      },
      hasScore: false,
      disabled: false,
      descTxt: '',
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true

      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(form)
        // (form.bnp < 100 ? 0 :	(form.bnp < 250 ? 1 :	(form.bnp < 500 ? 2 :	(form.bnp < 1000 ? 4 : 8)))) + (rvLvRatio < 0.5 ? 0 : (rvLvRatio < 0.75 ? 3 :	(rvLvRatio < 1 ? 5 :	(rvLvRatio <= 1.25 ? 8 : 11)))) + (alteredMentalState * 10) + (cardiogenicShock * 6) + (cancer * 6)
        //  form.
        let result = (form.bnp < 100 ? 0 : (form.bnp < 250 ? 1 : (form.bnp < 500 ? 2 : (form.bnp < 1000 ? 4 : 8)))) + (form.rvLvRatio < 0.5 ? 0 : (form.rvLvRatio < 0.75 ? 3 : (form.rvLvRatio < 1 ? 5 : (form.rvLvRatio <= 1.25 ? 8 : 11)))) + (form.alteredMentalState * 10) + (form.cardiogenicShock * 6) + (form.cancer * 6)
        if (result < 7) {
          self.descTxt = '低危，不良事件发生率是 2.5%'
        } else if (result > 17) {
          self.descTxt = '高危，不良事件发生率是 43.2%'
        } else {
          self.descTxt = '中危，不良事件发生率是 11.6%'
        }
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/PREP.vue